// extracted by mini-css-extract-plugin
module.exports = {"content":"Saved_content__ycy9n"};